import { Component , HostBinding } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TrackingDirective } from '../helpers/directive/tracking.directive';

@Component({
    selector: 'app-after-login-footer',
    templateUrl: './afterLoginFooter.component.html',
    styleUrls: ['./afterLoginFooter.component.css'],
    standalone: true,
    imports: [NgIf, TrackingDirective, RouterLink]
})
export class AfterLoginFooterComponent {

  showMyDataLogo:boolean= false;
  @HostBinding('style.width') public readonly WIDTH = '100%';

}
